import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import "./AppResponsive.css";

import ScrollToTop from "./components/items/ScrollToTop";

import AuthContextProvider from "./context/AuthContext";
import LinkContextProvider from "./context/LinkContext";

import MainRoute from "./Route/MainRoute";
function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthContextProvider>
        <LinkContextProvider>
          <div className="App darkbgColor" id="app">
            <div className="container">
              <div className="box-container">
                <MainRoute />
              </div>
            </div>
          </div>
        </LinkContextProvider>
      </AuthContextProvider>
    </Router>
  );
}

export default App;
